import React, { useState } from "react"
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import AppSidebar from "./AppSidebar";
import AppContentView from "./AppContentView";
import './../../App.css';

function AppLayout() {
  const { accounts } = useMsal();
  const isLoggedIn = (accounts && accounts[0]);
  const [sidebarHidden, setSidebarHidden] = useState<boolean>(false);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
        position: "relative",
        backgroundColor: (theme) => theme.palette.background.default,
        "& .mainContent": {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: { xs: "100%", lg: "100%" },
          transition: "all 0.5s ease",
          ml: { lg: !sidebarHidden ? "250px" : "25px" },
        }
      }}>
      {isLoggedIn && <AppSidebar sidebarHidden={sidebarHidden} setSidebarHidden={setSidebarHidden} />}
      <Box className="mainContent">
        <AppContentView />
      </Box>
    </Box >
  );
}

export default AppLayout;
